import styles from "./AdditionalMessage.module.scss";

type Props = {
  /**
   * An array of messages to be displayed by the component.
   */
  messages: string[];
};

export const AdditionalMessageUI = ({ messages }: Props) => {
  if (messages.length === 0) {
    return null;
  }

  return (
    <p data-testid="product:additional-message" className={styles.message}>
      {messages[0]}
    </p>
  );
};
